module.exports = __webpack_public_path__ + "img/diamonds-2.44306307.svg";